import React from 'react';
import type { TutorialStepT } from '../../../common/types/types';
const drawPolygon = {
  version: 1,
  id: 'draw-polygon',
  render: () => <div>Click on the stage to draw the polygon, polygon requires at least 3 vertices</div>,
  disableNext: true,
  nextId: 'end-polygon'
};
const endPolygon = {
  version: 1,
  id: 'end-polygon',
  render: () => <div>Click on the starting vertex to end the polygon.</div>,
  disableNext: true
};
export const POLYGON_TUTORIAL_CONFIG = {
  drawPolygon: ({
    ...drawPolygon,
    nextId: endPolygon.id
  } as Omit<TutorialStepT, 'getTarget'>),
  endPolygon: ({
    ...endPolygon
  } as Omit<TutorialStepT, 'getTarget'>)
};